exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".state-disclosure{margin:0 auto;padding-top:2rem}@media(min-width: 576px){.state-disclosure{padding-left:5rem;padding-right:5rem}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/components/Disclosure/StateDisclosure.scss
// module id = 7110
// module chunks = 13